<template>
  <div>
    <b-modal
      id="financeModal"
      :title="`${$t('billing_finance.title')}`"
      no-close-on-esc
      no-close-on-backdrop
      ref="financeModal"
      size="lg">
      <div>
        <validation-observer ref="refFormObserver">
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.month')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.month')"
                    rules="required">
                    <v-select
                      v-model="finance.month"
                      :options="monthOptions"
                      :clearable="false"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.year')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.year')"
                    rules="required">
                    <b-form-input
                      v-model="finance.year"
                      type="text"
                      maxlength="4"
                      :state="/^\d{4}$/.test(finance.year)"
                      placeholder="YYYY"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.region')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.region')"
                    rules="required">
                    <b-form-input
                      v-model="finance.region"
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.state')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.state')"
                    rules="required">
                    <b-form-input
                      v-model="finance.state"
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.rems')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.rems')"
                    rules="required">
                    <!-- <b-form-input
                      v-model="finance.rems"
                      type="text"
                    /> -->
                    <v-select
                      v-model="finance.id_unit"
                      :options="unitOptions"
                      :clearable="false"
                      :reduce="item => item.value"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.security_company')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.security_company')"
                    rules="required">
                    <!-- <b-form-input
                      v-model="finance.security_company"
                      type="text"
                    /> -->
                    <v-select
                      v-model="finance.id_provider"
                      :options="providerOptions"
                      :clearable="false"
                      :reduce="item => item.value"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.job_description')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.job_description')"
                    rules="required">
                    <b-form-input
                      v-model="finance.job_description"
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.number_of_services')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.number_of_services')"
                    rules="required">
                    <b-form-input
                      v-model="finance.number_of_services"
                      type="number"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.service_days')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.service_days')"
                    rules="required">
                    <v-select
                      v-model="finance.service_days"
                      :options="serviceDaysOptions"
                      :clearable="false"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.hours')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.hours')"
                    rules="required">
                    <b-form-input
                      v-model="finance.hours"
                      type="number"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.cost_per_shift')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.cost_per_shift')"
                    rules="required">
                    <b-form-input
                      v-model="finance.cost_per_shift"
                      type="number"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.type_of_guard')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.type_of_guard')"
                    rules="required">
                    <v-select
                      v-model="finance.type_of_guard"
                      :options="typeOfGuardOptions"
                      :clearable="false"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group :label="$t('billing_finance.work_schedule')">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('billing_finance.work_schedule')"
                    rules="required">
                    <v-select
                      v-model="finance.work_schedule"
                      :options="workScheduleOptions"
                      :clearable="false"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>

            </b-row>
          </b-form>
        </validation-observer>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="onClose">
          {{ $t("actions.cancel").charAt(0).toUpperCase() + $t("actions.cancel").slice(1) }}
        </b-button>
        <b-button
          @click="onSubmit"
          variant="success"
        >
          <b-spinner small v-if="loading"></b-spinner>
          <span v-else>
            {{
              $t("actions.save")
            }}
          </span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { useFinance } from './finance';
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    currentItemToEdit: {
      type: Object,
      default: () => {},
    },
    providerOptions: {
      type: Array,
      default: () => [],
    },
    unitOptions: {
      type: Array,
      default: () => [],
    },
    fetchList: {
      type: Function,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    
    const {
      finance,
      monthOptions,
      serviceDaysOptions,
      typeOfGuardOptions,
      workScheduleOptions,
      loading,
      refFormObserver,
      getValidationState,
      loadEditData,
      onClose,
      onSubmit
    } = useFinance(props.isEdit, emit, props.fetchList);

    loadEditData(props.currentItemToEdit);


    return {
      finance,
      monthOptions,
      refFormObserver,
      serviceDaysOptions,
      typeOfGuardOptions,
      workScheduleOptions,
      loading,
      getValidationState,
      loadEditData,
      onClose,
      onSubmit
    }
  },
}
</script>